/* unplugin-vue-components disabled */import script from "./CIFA.vue?vue&type=script&setup=true&lang=js"
export * from "./CIFA.vue?vue&type=script&setup=true&lang=js"

import "./CIFA.vue?vue&type=style&index=0&id=618d7164&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618d7164"]])

export default __exports__